<template>
    <div>
        <app-mobile-menu @logout="openModal('logout-window')" @profile="openPageUserAccount"></app-mobile-menu>
        <app-context-info @logout="openModal('logout-window')" @profile="openPageUserAccount"></app-context-info>
        <b-modal title="¿Esta seguro de salir?" id="logout-window" cancel-title="Cancelar" ok-title="Salir" @ok="logout">
            <p class="my-4">Seleccione Salir si desea finalizar su sesión</p>
        </b-modal>
    </div>
</template>

<script>
import appMobileMenu from './MobileMenu'
import appContextInfo from './ContextInfo'
export default {
    components: {
        appMobileMenu,
        appContextInfo,
    },
    methods: {
        async logout() {
            try {
                const { data } = await this.$repo.post('logout')
                localStorage.clear()
                this.clearCookies()
                this.clearState()
                this.closeModal('logout-window')
            } catch (error) {
                console.log({ error })
            } finally {
                // this.$router.replace('/')
                this.$router.push({ name: 'login' })
            }
        },
        openPageUserAccount() {
            if (this.$route.name === 'userAccount') return
            this.$router.push({
                name: 'userAccount',
            })
        },
        clearCookies() {
            var cookies = document.cookie.split(';')

            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i]
                var eqPos = cookie.indexOf('=')
                var name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie

                // Cookie appversion is not deleted for automatic update
                if (name === 'appversion') continue
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
            }
        },
    },
}
</script>

<style></style>
